import React from 'react';
import { Link } from 'react-router-dom';
import LandingHeader from '../../components/LandingHeader';
import './Landing.css';

/**
 * Landing page component
 * Main entry point for non-authenticated users
 */
const LandingPage = () => {
  return (
    <div className="landing-page">
      <LandingHeader />
      <div className="hero-section">
        <div className="hero-content">
          <h1>Unissn</h1>
          <p className="hero-subtitle">
            Unissn (pronounced "unison") is building a platform where musicians, artists, and professionals in the Detroit area and beyond can connect — with each other, and with the gigs and venues that bring their work to life.
          </p>
          <p className="hero-message">
            Whether you're looking to get booked, fill a lineup, gain experience, or collaborate with creative talent — Unissn exists to bring the scene together.
          </p>
          <div className="cta-buttons">
            <Link to="/register?type=artist" className="btn btn-primary btn-large">
              Create a Profile
            </Link>
            <Link to="/register?type=venue" className="btn btn-secondary btn-large">
              Post a Gig
            </Link>
          </div>
        </div>
      </div>

      <div className="features-section">
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🎵</div>
            <h3>Connect with Gigs and Venues</h3>
            <p>Find local opportunities to perform, teach, assist, or engineer. From small sessions to large events, Unissn helps you discover work in your area.</p>
          </div>

          <div className="feature-card">
            <div className="feature-icon">🔍</div>
            <h3>Discover Musicians and Professionals</h3>
            <p>Search for drummers, DJs, vocalists, techs, teachers, producers, and more. Whether you're building a band or running a show — Unissn helps you build your team.</p>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">🤝</div>
            <h3>Book, Build, Collaborate</h3>
            <p>We make it easier to meet the right people in your city. This is your creative network — built for action, not just social.</p>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h2>Ready to Get Started?</h2>
        <p>Join Unissn today and take your music career to the next level</p>
        <Link to="/register" className="btn btn-primary btn-large">
          Register Now
        </Link>
      </div>
    </div>
  );
};

export default LandingPage;
